export default __webpack_public_path__ + "static/media/client.833a4882.png";